import React from 'react';
import { Logo } from './Logo';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-ink px-5 py-14 text-center sm:px-8" data-id="element-77" data-mp="3ggaq1tbg494e">
      <div className="mx-auto flex w-full max-w-2xl flex-col items-center" data-id="element-78" data-mp="32ovwwtntqrjm">
        <Logo data-id="element-79" data-mp="36oxzr65apr0h" />

        <p className="mt-4 text-sm font-semibold text-white/70" data-id="element-80" data-mp="36oo5359b2vog">
          The complete toolkit for flag football coaches
        </p>

        <ul className="mt-6 flex items-center justify-center gap-2 text-sm font-semibold text-white/65" data-id="element-81" data-mp="3uftlpmn2lrzt">
          {footerLinks.map(link => <li key={link.label} data-id="element-82" data-mp="3levg4zwzhcf4">
              <a href={link.href} className="inline-flex min-h-[44px] items-center px-3 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/50" data-id="element-83" data-mp="3ldkgncakmqtt">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-xl text-xs leading-relaxed text-white/45" data-id="element-84" data-mp="3l9k1v1qqp380">
          Digital product. Not affiliated with or endorsed by any league or governing
          body.
        </p>
      </div>
    </footer>;
}